import AutorenewOutlined from '@mui/icons-material/AutorenewOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined';
import PercentOutlined from '@mui/icons-material/PercentOutlined';

import ShareResourceBanner from '~components/ShareResourceBanner/ShareResourceBanner';
import { ShareResourceBannerConfig } from '~components/ShareResourceBanner/shareResourceBannerTypes';

const RECURRING_ADD_ONS_EXPLAINER_CONFIG: ShareResourceBannerConfig = {
  testIdPrefix: 'recurring-settlement-add-ons-explainer',
  Icon: AutorenewOutlined,
  translationNamespace: 'administration.recurring_settlement_add_ons_explainer',
  steps: [
    {
      titleKey:
        'administration.recurring_settlement_add_ons_explainer.steps.step_1_title',
      subtitleKey:
        'administration.recurring_settlement_add_ons_explainer.steps.step_1_subtitle',
    },
    {
      titleKey:
        'administration.recurring_settlement_add_ons_explainer.steps.step_2_title',
      subtitleKey:
        'administration.recurring_settlement_add_ons_explainer.steps.step_2_subtitle',
    },
    {
      titleKey:
        'administration.recurring_settlement_add_ons_explainer.steps.step_3_title',
      subtitleKey:
        'administration.recurring_settlement_add_ons_explainer.steps.step_3_subtitle',
    },
  ],
  stepsLayout: 'column',
  showStepsSectionLabel: false,
  aside: {
    kind: 'examples',
    items: [
      {
        Icon: PercentOutlined,
        titleKey:
          'administration.recurring_settlement_add_ons_explainer.examples.broker_fee_title',
        detailKey:
          'administration.recurring_settlement_add_ons_explainer.examples.broker_fee_detail',
      },
      {
        Icon: LocalShippingOutlined,
        titleKey:
          'administration.recurring_settlement_add_ons_explainer.examples.truck_rental_title',
        detailKey:
          'administration.recurring_settlement_add_ons_explainer.examples.truck_rental_detail',
      },
      {
        Icon: PaymentsOutlined,
        titleKey:
          'administration.recurring_settlement_add_ons_explainer.examples.supplemental_pay_title',
        detailKey:
          'administration.recurring_settlement_add_ons_explainer.examples.supplemental_pay_detail',
      },
    ],
  },
};

const RecurringAddOnsExplainerBanner = () => (
  <ShareResourceBanner config={RECURRING_ADD_ONS_EXPLAINER_CONFIG} />
);

export default RecurringAddOnsExplainerBanner;
